import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitoshirdireturncabs() {



  const cardData =
  {
    keyword: 'Mumbai to Shirdi Return Cab',
    heading: 'Sai Trupti Cabs: Mumbai to Shirdi Return Cab',
    headingDescription: 'Sai Trupti Cabs offers reliable and comfortable Mumbai to Shirdi return cab services, designed to make your pilgrimage or outing smooth and stress-free. Our fleet includes well-maintained, air-conditioned Sedans, SUVs, and Premium vehicles — all equipped with clean interiors and ample luggage space. Every journey is driven by a professional, background-verified chauffeur who ensures punctual pickup in Mumbai, courteous service, and safe, smooth driving all the way to Shirdi and back. With transparent return-trip fares, flexible booking options (one-way or round-trip), and 24×7 customer support, Sai Trupti Cabs makes your travel from Mumbai to Shirdi and return convenient, affordable and worry-free.',

    top: 'Top Places to Visit in Shirdi with Sai Trupti Cabs',

"topPlaces": [
  {
    "title": "Shri Sai Baba Samadhi Mandir",
    "description": "The Shri Sai Baba Samadhi Mandir is the spiritual heartbeat of Shirdi and one of the most visited temples in India. Built from white marble, the temple houses the sacred tomb of Sai Baba, whose teachings of love, faith, and unity continue to guide millions. Devotees from across the world queue from early morning to attend Kakad Aarti and seek his blessings. The atmosphere resonates with bhajans, incense, and heartfelt prayers, creating an aura of divine peace. The temple complex also includes meditation halls, gardens, and shrines that reflect simplicity and devotion. For every pilgrim, a visit to this Mandir is both a spiritual awakening and a moment of serenity in Shirdi’s divine embrace."
  },
  {
    "title": "Dwarkamai Mosque",
    "description": "Dwarkamai holds profound importance in the life of Sai Baba, who spent a significant part of his life here. Once a dilapidated mosque, Sai Baba transformed it into a symbol of religious harmony and compassion. Inside, the sacred dhuni (fire) burns continuously since his time, representing the eternal flame of faith and hope. The walls, adorned with lamps and photos, whisper stories of miracles and selfless service. Devotees light candles and offer prayers here, feeling an intimate connection with Sai Baba’s teachings. Dwarkamai isn’t just a structure — it is where the saint’s divine energy still radiates warmth and solace to all who enter."
  },
  {
    "title": "Chavadi",
    "description": "Located near Dwarkamai, Chavadi is the humble resting place where Sai Baba spent every alternate night during the last years of his life. The structure, preserved with care, features wooden benches, portraits, and Baba’s personal belongings. Every Thursday, a grand procession known as 'Palki Utsav' is held, where Sai Baba’s portrait and Padukas are carried with music, chants, and devotion. The air fills with rhythm and reverence as thousands join the parade through the streets of Shirdi. Visiting Chavadi feels like walking alongside history, where faith and memory merge. It’s a sacred corner of Shirdi that keeps Sai Baba’s presence alive through timeless rituals."
  },
  {
    "title": "Sai Heritage Village",
    "description": "Sai Heritage Village is a beautiful theme park that blends devotion with history and art. Through realistic sculptures and scenic sets, it depicts key events from Sai Baba’s life and the lives of his devotees. Lush greenery, traditional cottages, and water features make it a peaceful escape for families. Visitors can also enjoy a small amusement area and local snacks, making it a blend of pilgrimage and recreation. The village provides an educational journey into Shirdi’s past, offering insights into Baba’s humility and compassion. It’s a soulful experience that connects the younger generation with faith through storytelling and creativity."
  },
  {
    "title": "Shirdi Water Park (Wet n Joy)",
    "description": "Wet n Joy Water Park in Shirdi offers a refreshing break for travelers after spiritual exploration. Spread over 10 acres, it features thrilling rides, wave pools, lazy rivers, and family-friendly attractions. The park maintains high safety and hygiene standards, making it ideal for families and groups. The lush landscaping and cool water contrast beautifully with Shirdi’s warm climate. After days of pilgrimage, visitors often unwind here, adding a touch of fun to their holy journey. Wet n Joy shows Shirdi’s evolving side — a destination where devotion and delight flow hand in hand."
  },
  {
    "title": "Lendi Baug",
    "description": "Lendi Baug is a tranquil garden that Sai Baba personally tended during his lifetime. He would water the plants here every morning and meditate under a neem tree, which still stands as a sacred symbol. The garden’s calm paths, fountains, and greenery invite visitors to reflect and find inner peace. At its heart burns a perpetually lit lamp, placed by Baba himself, symbolizing eternal faith and compassion. Birds chirp softly, leaves rustle, and devotees walk silently, feeling a deep connection to Baba’s presence. Lendi Baug is more than a garden — it is a living memory of his simplicity, service, and oneness with nature."
  },
  {
    "title": "Khandoba Temple",
    "description": "Khandoba Temple is one of Shirdi’s most significant historic landmarks, marking the very place where Sai Baba first set foot in the village. Dedicated to Lord Khandoba, the temple’s priest, Mhalsapati, was the first to address Baba as 'Sai,' giving him the name the world knows today. The temple, though modest, exudes deep spiritual significance and symbolizes the beginning of Baba’s divine journey in Shirdi. The main shrine houses idols of Lord Khandoba, Banai, and Mhalsai. Pilgrims visit here to honor the moment destiny brought the saint to Shirdi — where compassion, faith, and miracles began."
  },
  {
    "title": "Upasani Maharaj Ashram",
    "description": "Located in Sakori village near Shirdi, the Upasani Maharaj Ashram carries forward the legacy of Sai Baba through his devoted disciple, Upasani Maharaj. The ashram radiates serenity, with its meditation halls, shrines, and spiritual learning centers. Followers come here for introspection and to understand Baba’s teachings on humility, devotion, and self-realization. The tranquil surroundings of Sakori village enhance the ashram’s spiritual charm. It’s a place where time seems to slow down, and the divine message of service and faith continues to echo in simplicity. Visiting this ashram feels like extending one’s Shirdi journey into deeper spiritual exploration."
  },
  {
    "title": "Shani Shingnapur Temple",
    "description": "About 75 km from Shirdi lies the famous Shani Shingnapur Temple, dedicated to Lord Shani (Saturn), known as the guardian of justice. Unique for having no roof over the deity and no doors in village houses, it symbolizes absolute trust and divine protection. Pilgrims visit from all over India to perform rituals and seek blessings for peace and prosperity. The temple’s black stone idol, open to the sky, radiates a powerful aura. The journey from Shirdi to Shani Shingnapur combines faith, wonder, and rural beauty. Together, these twin pilgrimages form a sacred circuit for seekers of truth and divine balance."
  },
  {
    "title": "Dixit Wada Museum",
    "description": "Dixit Wada Museum is a small yet deeply moving museum located within the temple complex. It houses personal belongings of Sai Baba — his clothes, utensils, photographs, and walking stick — all carefully preserved by early devotees. The old photographs and letters take visitors back to the days when Shirdi was a quiet village touched by divinity. Each artifact tells a story of simplicity and love. The museum offers not just a glimpse of history but an emotional connection to Baba’s earthly life. For true followers, Dixit Wada is a sacred archive of faith frozen in time."
  }
],



"services": [
  {
    "name": "Mumbai to Shirdi Return Cab",
    "description": "Book comfortable Mumbai to Shirdi return cabs for a safe, hassle-free journey. Choose from AC and non-AC vehicles including Sedans, SUVs, and luxury cars. Travel with experienced drivers familiar with long-distance routes, enjoy flexible pickup and drop points, and benefit from transparent pricing. Perfect for family trips, weekend getaways, group travel, or corporate journeys, with easy online booking, instant confirmation, and 24/7 support ensuring a smooth ride."
  },
  {
    "name": "Mumbai to Shirdi Taxi Service",
    "description": "Hire a Mumbai to Shirdi taxi for a stress-free and scenic journey. Well-maintained vehicles, courteous drivers, and flexible schedules make it ideal for tourists, business travelers, and families. One-way or round-trip options are available with transparent fare policies."
  },
  {
    "name": "Mumbai to Shirdi Car Hire",
    "description": "Rent a car from Mumbai to Shirdi for personalized and comfortable travel. Choose from Sedans, SUVs, and luxury vehicles with AC/non-AC options. Benefit from professional drivers, luggage assistance, flexible routes, and safe travel. Ideal for families, groups, or business trips seeking convenience and comfort."
  },
  {
    "name": "AC Cab Mumbai to Shirdi",
    "description": "Travel comfortably with AC cab service from Mumbai to Shirdi. Enjoy clean, air-conditioned vehicles, skilled drivers, flexible pickup points, and smooth, safe travel. Suitable for families, couples, and solo travelers looking for a relaxed long-distance journey."
  },
  {
    "name": "Non AC Cab Mumbai to Shirdi",
    "description": "Affordable non-AC cab service from Mumbai to Shirdi for budget-conscious travelers. Reliable drivers, well-maintained cars, and flexible pickup/drop points ensure safe, comfortable, and economical travel over long distances."
  },
  {
    "name": "Innova Cab Mumbai to Shirdi",
    "description": "Book spacious and comfortable Innova cabs from Mumbai to Shirdi. Ideal for families or groups, featuring AC comfort, ample legroom, luggage space, and experienced drivers. Enjoy smooth travel on highways and city roads for a stress-free journey."
  },
  {
    "name": "Ertiga Cab Mumbai to Shirdi",
    "description": "Affordable and convenient group travel with Ertiga cabs from Mumbai to Shirdi. AC/non-AC options, comfortable seating, luggage space, and professional drivers ensure a safe and enjoyable ride. Perfect for friends, families, or corporate groups."
  },
  {
    "name": "Luxury Cab Mumbai to Shirdi",
    "description": "Travel in style with luxury cab services from Mumbai to Shirdi. Premium Sedans and SUVs with elegant interiors, AC service, and professional chauffeurs make it ideal for VIP guests, business executives, or special occasions. Experience comfort, safety, and prestige throughout the journey."
  },
  {
    "name": "Affordable Cab Mumbai to Shirdi",
    "description": "Get pocket-friendly Mumbai to Shirdi cab services with transparent fares, AC/non-AC options, and professional drivers. Flexible timings, easy booking, and reliable service make it perfect for solo travelers, students, and small families looking for value-for-money travel."
  },
  {
    "name": "Mumbai to Shirdi Outstation Cab",
    "description": "Reliable outstation cab service from Mumbai to Shirdi ideal for weekend trips, sightseeing, or long stays. Choose from a variety of vehicles, enjoy AC/non-AC comfort, flexible bookings, and safe travel with experienced drivers for a hassle-free interstate journey."
  },
  {
    "name": "Mumbai to Shirdi One Way Cab",
    "description": "Book one-way cabs from Mumbai to Shirdi at affordable rates. Point-to-point travel, clean vehicles, professional drivers, and flexible pickups make it ideal for travelers heading to Shirdi without return plans."
  },
  {
    "name": "Mumbai to Shirdi Drop Cab",
    "description": "One-way drop cab service from Mumbai to Shirdi with flexible timings, AC/non-AC options, and professional drivers. Enjoy a smooth, comfortable ride perfect for single transfers, business trips, or leisure travel."
  },
  {
    "name": "Corporate Cab Mumbai to Shirdi",
    "description": "Premium corporate cab hire from Mumbai to Shirdi with executive vehicles, professional chauffeurs, and flexible travel schedules. Ideal for conferences, business meetings, client visits, and corporate events, offering comfort, punctuality, and reliability."
  },
  {
    "name": "Wedding Cab Mumbai to Shirdi",
    "description": "Elegant wedding cab service from Mumbai to Shirdi with luxury interiors, AC comfort, professional drivers, and on-time pickups. Perfect for bride/groom transfers, guest transport, and event logistics with complete reliability and style."
  },
  {
    "name": "Online Cab Booking Mumbai to Shirdi",
    "description": "Book your Mumbai to Shirdi cab online with instant confirmation, secure payment, and transparent fares. Choose from Sedans, Innova, and Ertiga for a convenient, stress-free journey. Ideal for last-minute travel, weekend trips, or planned travel with complete convenience."
  }
],
"tableData": [
  ["Mumbai to Shirdi Return Cab", "Mumbai to Shirdi Taxi Service"],
  ["Mumbai to Shirdi Car Hire", "AC Cab Mumbai to Shirdi"],
  ["Non AC Cab Mumbai to Shirdi", "Innova Cab Mumbai to Shirdi"],
  ["Ertiga Cab Mumbai to Shirdi", "Luxury Cab Mumbai to Shirdi"],
  ["Affordable Cab Mumbai to Shirdi", "Mumbai to Shirdi Outstation Cab"],
  ["Mumbai to Shirdi One Way Cab", "Mumbai to Shirdi Drop Cab"],
  ["Online Cab Booking Mumbai to Shirdi", "Corporate Cab Mumbai to Shirdi"],
  ["Wedding Cab Mumbai to Shirdi", ""]
],


"whychoose": [
  {
    "WhyChooseheading": "Mumbai to Shirdi Return Cabs",
    "WhyChoosedescription": "Sai Trupti Cabs provides comfortable and reliable return cab services from Mumbai to Shirdi — perfect for pilgrims, family trips, and leisure journeys."
  },
  {
    "WhyChooseheading": "Transparent & Competitive Fare",
    "WhyChoosedescription": "Enjoy affordable and transparent fares for Mumbai to Shirdi return cabs — no hidden charges, no surge pricing, ensuring full value for your money."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicle Options",
    "WhyChoosedescription": "Choose from hatchbacks, sedans, SUVs, and premium cars according to your comfort, group size, and budget for the Mumbai–Shirdi return route."
  },
  {
    "WhyChooseheading": "Professional & Experienced Drivers",
    "WhyChoosedescription": "Our courteous and skilled drivers are familiar with the Mumbai to Shirdi route, guaranteeing a safe, smooth, and timely return journey."
  },
  {
    "WhyChooseheading": "Flexible Pickup & Drop Locations",
    "WhyChoosedescription": "We provide convenient pickups from anywhere in Mumbai — airport, home, or office — and drop-offs at your preferred location in Shirdi and back to Mumbai."
  },
  {
    "WhyChooseheading": "Clean & Well-Maintained Vehicles",
    "WhyChoosedescription": "Sai Trupti Cabs maintains clean, sanitized, and regularly serviced vehicles to ensure a comfortable and reliable round-trip experience every time."
  },
  {
    "WhyChooseheading": "24/7 Booking & Customer Support",
    "WhyChoosedescription": "Our customer support team is available 24/7 to assist with bookings, travel details, or route information for your Mumbai to Shirdi return cab trip."
  },
  {
    "WhyChooseheading": "Hassle-Free Booking Process",
    "WhyChoosedescription": "Book your Mumbai to Shirdi return cab easily via call, WhatsApp, or our website — get instant confirmation and enjoy a smooth, stress-free journey."
  }
]






























  }

const faqData = [
  {
    question: 'Does Sai Trupti Cabs offer Mumbai to Shirdi return cab services?',
    answer: 'Yes, Sai Trupti Cabs provides safe, reliable, and affordable Mumbai to Shirdi return cab services for one way, round trips, and group or family travel.',
  },
  {
    question: 'How can I book a Mumbai to Shirdi return cab with Sai Trupti Cabs?',
    answer: 'You can easily book your Mumbai to Shirdi return cab through our website, mobile app, or by contacting our 24×7 customer support team for instant booking assistance.',
  },
  {
    question: 'What types of cabs are available for Mumbai to Shirdi trips?',
    answer: 'We offer a range of well-maintained vehicles including hatchbacks, sedans, SUVs, Ertiga, Innova Crysta, and tempo travellers—ideal for families, groups, and solo travelers.',
  },
  {
    question: 'Are the drivers experienced for Mumbai to Shirdi routes?',
    answer: 'Yes, all our drivers are professional, courteous, and experienced with the Mumbai–Shirdi route, ensuring a comfortable and safe travel experience.',
  },
  {
    question: 'Can I book a cab for local sightseeing in Shirdi?',
    answer: 'Of course! Sai Trupti Cabs offers local sightseeing packages in Shirdi for attractions like Sai Baba Temple, Dwarkamai, Chavadi, and Lendi Baug.',
  },
  {
    question: 'Is the Mumbai to Shirdi return cab service available 24×7?',
    answer: 'Yes, Sai Trupti Cabs operates 24×7 Mumbai to Shirdi return cab services so you can plan your trip anytime according to your convenience.',
  },
  {
    question: 'What are the Mumbai to Shirdi return cab fares?',
    answer: 'Our Mumbai to Shirdi return cab fares start from ₹3,000 for sedans and ₹3,800–₹4,500 for SUVs or Innova Crysta, depending on your travel plan and vehicle choice.',
  },
  {
    question: 'What payment options are available for Mumbai to Shirdi return cab bookings?',
    answer: 'We accept payments via UPI, credit/debit cards, digital wallets, and bank transfers for a seamless and secure transaction experience.',
  },
  {
    question: 'What safety and hygiene measures are followed for Mumbai to Shirdi cabs?',
    answer: 'All our cabs are sanitized before each ride, and our drivers follow strict hygiene and safety protocols to ensure a worry-free journey.',
  },
  {
    question: 'Is customer support available during the Mumbai to Shirdi cab journey?',
    answer: 'Yes, Sai Trupti Cabs provides round-the-clock customer support to assist you during your Mumbai to Shirdi trip.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Santosh Patil',
    feedback: 'Our Mumbai to Shirdi return trip with Sai Trupti Cabs was seamless. Comfortable cab, polite driver, and excellent service throughout.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Mrs. Anjali Deshmukh',
    feedback: 'Highly recommend Sai Trupti Cabs for Mumbai to Shirdi return trips. Punctual, clean cars, and very professional drivers made our journey stress-free.',
    rating: 5,
  },
];




























































































  const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
  { place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
  { place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
  { place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
  { place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
  { place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
  { place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
  { place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cab", link: "Hinjewadi-to-Mumbai-Cab" },
  { place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cab", link: "Wakad-to-Mumbai-Cab" },
  { place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cab", link: "Hadapsar-to-Mumbai-Cab" },
  { place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
  { place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cab", link: "Koregaon-Park-to-Mumbai-Cab" },
  { place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cab", link: "Kothrud-to-Mumbai-Cab" },
  { place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cab", link: "Kharadi-to-Mumbai-Cab" },
  { place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cab", link: "Shivajinagar-to-Mumbai-Cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cab", link: "Pune-to-Mumbai-Innova-Crysta-Cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
  { place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cab", link: "Kondhwa-to-Mumbai-Cab" },
  { place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
  { place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];


















const productSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Mumbai to Shirdi Return Cab",
  "image": "https://saitrupticabs.com/assets/images/mumbai-to-shirdi-return-cab.jpg", // Replace with actual image URL
  "description": "Book return cabs from Mumbai to Shirdi with Sai Trupti Cabs. Choose AC, Non-AC, Innova, Ertiga, luxury rides, one-way trips, drop services, corporate travel, weddings, or outstation trips. Affordable 24x7 online booking available.",
  "provider": {
    "@type": "Organization",
    "name": "Sai Trupti Cabs",
    "url": "https://saitrupticabs.com"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1500"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "4500", // Example price, adjust according to actual rates
    "availability": "https://schema.org/InStock",
    "url": "https://saitrupticabs.com/mumbai-to-shirdi-return-cab-booking"
  }
};



  return (
    <div>
<Helmet>
  <title>Mumbai to Shirdi Return Cab | Sai Trupti Cabs</title>
  <meta 
    name="description" 
    content="Book return cabs from Mumbai to Shirdi with Sai Trupti Cabs. Choose AC, Non-AC, Innova, Ertiga, luxury rides, one-way trips, drop services, corporate travel, weddings, or outstation trips. Affordable 24x7 online booking available." 
  />
  <meta 
    name="keywords" 
    content="Mumbai to Shirdi Return Cab, Mumbai to Shirdi Taxi Service, Mumbai to Shirdi Car Hire, AC Cab Mumbai to Shirdi, Non AC Cab Mumbai to Shirdi, Innova Cab Mumbai to Shirdi, Ertiga Cab Mumbai to Shirdi, Luxury Cab Mumbai to Shirdi, Affordable Cab Mumbai to Shirdi, Mumbai to Shirdi Outstation Cab, Mumbai to Shirdi One Way Cab, Mumbai to Shirdi Drop Cab, Corporate Cab Mumbai to Shirdi, Wedding Cab Mumbai to Shirdi, Online Cab Booking Mumbai to Shirdi" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

<section
      className="breadcrumb-section"
      style={{ backgroundImage: "url(/images/background/inner-banner-bg.png)" }}
    >
      <div className="container">
        <div className="banner-content">
          <h1> {cardData.keyword}</h1>
        </div>
      </div>
    </section>



      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/78.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sai Trupti Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sai Trupti Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918390907004" className="pc-call">+91 8390907004</a>
                      <a href="tel:+919922727744" className="pc-call">+91 9922727744</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918390907004"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918390907004" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@saitrupticabs.com" className="pc-email">
                      booking@saitrupticabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sai Trupti Cabs </strong><br />
                      Yashoda splendid Park,
                      Office number D. Wing Dudulgaon Anandi,
                        ruial Sainath Chowk Alandi-412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitoshirdireturncabs;